import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Обо мне`}</h2>
    <h5>{`Люблю доводить дело до конца, получаю заряд от выполненной работы!`}</h5>
    <p>{`Сама по себе креативна и дружелюбна, больше всего люблю природу, музыку и улыбки людей :)
Закончила школу с золотой медалью, на данный момент учусь в университете на 3-м курсе. Участвовала в ШИФТ 2020, буду принимать участие Yandex Cup'20.  `}</p>
    <ul>
      <li parentName="ul">{`Уверенное знание HTML, CSS (SCSS) и основных принципов адаптивной верстки;`}</li>
      <li parentName="ul">{`БЭМ, JavaScript (в процессе изучения);`}</li>
      <li parentName="ul">{`Верстка по макетам Figma, Adobe Photoshop;`}</li>
      <li parentName="ul">{`Знакома с React.js, Next.js, Redux, Strapi;`}</li>
      <li parentName="ul">{`Опыт работы c Webpack, Git;`}</li>
      <li parentName="ul">{`Знание СУБД Access, базовые запросы SQL.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      